export enum BrowserName {
  Chrome = "Chrome",
  Firefox = "Firefox",
  Brave = "Brave",
  Edge = "Edge",
  Opera = "Opera",
  Safari = "Safari",
}
